/**
 * Initialize carrier composable
 * Validate FF and user role
 * If user has insufficient credentials redirect to 403 page
 */
import { newFeatures } from '@/constants/newFeatures';
import { uselocalStorageGetterSetter } from '@/composables/uselocalStorageGetterSetter';

export default defineNuxtRouteMiddleware(async (to) => {
  const { isCarrierProfileEnabled } = await useIsCarrierProfileEnabled();
  const { setObject, getNewFeaturesObject, setNewFeaturesObject } =
    uselocalStorageGetterSetter();

  const carrierProfileIsNewObj = {
    [newFeatures.isCarrierProfileNew]: true,
    [newFeatures.isMobileCarrierProfileNew]: true,
  };

  const newFeaturesObj = getNewFeaturesObject();

  if (!isCarrierProfileEnabled.value) {
    return navigateTo('/403');
  }

  if (!newFeaturesObj) {
    setObject('NEW_FEATURES', carrierProfileIsNewObj);
  }

  // cannot rely on logical not (!variable) since the dismiss function sets the value of the prop to false
  if (newFeaturesObj[newFeatures.isMobileCarrierProfileNew] === undefined) {
    setNewFeaturesObject({ [newFeatures.isMobileCarrierProfileNew]: true });
  }

  /**
   * Set "Your Profile" as the default page
   */
  if (
    to.fullPath === '/carrier-profile' ||
    to.fullPath === '/carrier-profile/'
  ) {
    return navigateTo({
      path: '/carrier-profile/your-profile',
    });
  }
});
